var map = {
	"./code-ton-asso-screenshot.webp": 614,
	"./frisbee-screenshot.webp": 718,
	"./le-bon-appart-screenshot.webp": 583,
	"./marilene-picture-b&w.png": 24,
	"./marilene-picture-b&w.webp": 383,
	"./marilene-picture-color.png": 846,
	"./marilene-picture-color.webp": 827,
	"./mytodolistapp-screenshot.webp": 968,
	"./spa-gestion-screenshot.webp": 417,
	"./team-m-screenshot.webp": 405,
	"./yahtzee-game-screenshot.webp": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;